import React from "react";
import NewsletterForm from "./NewsletterForm";

// Reader has just finished the article, so the pitch picks up from there rather
// than reusing the cold-open heading the home page and popup share. It names
// the newsletters: this is the Weekend Reads list, not a "next post" alert.
const EnjoyedThisHeading = () => (
  <>
    <h2>
      Enjoyed this? <em>There's more.</em>
    </h2>
    <p className="lead">
      Weekend Reads every Friday, Weekday Wisdom every Tuesday.
      <span className="lead-offer">
        Plus <strong>10% off your next purchase</strong>, right away.
      </span>
    </p>
  </>
);

// Permanent signup band under a blog post. The exit-intent popup only catches
// readers on their way out; this catches the ones who finish the article and
// are still on the page.
const NewsletterInline = () => (
  <section className="newsletter-inline" aria-label="Newsletter signup">
    <NewsletterForm heading={<EnjoyedThisHeading />} />
  </section>
);

export default NewsletterInline;
